import React from 'react';
import './App.css';
import Dashboard from './components/dashboard/Dashboard';

function App() {
  return (
    <Dashboard />
  );
}

export default App;
